import {

} from "../types";
import axios from "axios";
import {firebase} from '../../../firebase/initFirebase'
import moment from 'moment'
import {store} from '../../store'
import { message} from 'antd';
import S3 from 'react-aws-s3';

export const calculateWeightedExchangeRate = () => {
  return async(dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection('exchangerate')
    dataRef.where("created_at" , '>' , moment().format('YYYY-MM-DD HH:mm:ss'))

    dataRef.get()
    var exchangerateSnapshot = await dataRef.get()
    var docs = exchangerateSnapshot.docs
    var numerator = 0
    var denominator = 0 
    docs.map(item=>{         
        var newItem={
          key:item.id,
          id:item.id,
          ...item.data()
        }
        console.log(newItem)
        if( moment().diff(moment(newItem.created_at),'months', true) <= 3){
          numerator = numerator + (parseFloat(newItem.rate)*(parseFloat(newItem.amount)))
          denominator = denominator +  parseFloat(newItem.amount)
        }
      
    })
    if(denominator !== 0){
      var final = numerator/denominator
      var data2Ref = Firestore.collection('config').doc('weightedexchangerate')
      var setthis = data2Ref.set({value:final},{merge: true})
   
      return(final.toFixed(2))
    }
  
  };
};


export const getWeightedExchangeRate =  () => {
  return  async (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection('config').doc('weightedexchangerate')
    var newd = dataRef.get().then((doc) => {
      if (doc.exists) {
          // console.log("Document data:", doc.data());
          var newdata =  doc.data()
          return( newdata)
      } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
      }
  }).catch((error) => {
      console.log("Error getting document:", error);
  });
  return(newd)
     
  }
};